import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './Roof.module.css';

export default function Roof({ 
    surfaceName = 'Roof', 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Selection key: StepName_Room (e.g., Roof_Exterior)
    const selectionKey = `Roof_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedProduct(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        
        console.log('Roof - Product selected:', product.color || product.name);
        console.log('Roof - Applying to surface:', surfaceName);
        
        // Store selection in Redux with room-based key
        dispatch(selectProduct({
            product,
            surfaceName,
            stepIndex,
            selectionKey
        }));
        
        // Apply product to Chameleon visualization
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('Roof - chamViz element not found');
            return;
        }

        if (!product.id) {
            console.error('Roof - Product has no ID');
            return;
        }

        console.log('Roof - Applying product ID:', product.id);
        dispatch(setVizLoading(true));
        
        // Apply by surface name using product ID
        chamViz.applyByFilter(
            product.id, // Product ID, not specifier
            "",
            function(newSel) {
                // this = surface object { name, type, sortorder, sel }
                if (this.name === surfaceName) {
                    return newSel; // Apply the product
                }
                return this.sel; // Keep existing selection
            },
            true // auto-apply
        );
    };

    const handleViewAllApplied = () => {
        if (onViewAllApplied) {
            onViewAllApplied();
        }
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Roof"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={handleViewAllApplied}
            />

            <div className={styles.productListContainer}>
                <ProductList
                    seriesId="9722"
                    thumbSize="256"
                    onProductSelect={handleProductSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedProduct?.id}
                />
            </div>
        </div>
    );
}

Roof.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
